module.exports = __webpack_public_path__ + "img/transfer-cert-authorize.88209485.png";